module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Attachment1-28137b5cc797c4d96910ad505995a671.svg";